import { useContext } from 'react';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import API_URL from '../constants/environment';
import SessionContext from '../contexts/SessionContext';

export type SettingsPreset = 'oem-only' | 'high-margin' | 'custom';

interface CreateOrgSettingsInput {
	organizationId: string;
	preset: SettingsPreset;
}

export const useCreateOrganizationSettings = () => {
	const sessionContext = useContext(SessionContext);
	return useMutation({
		mutationFn: async (input: CreateOrgSettingsInput) => {
			const { data } = await axios.post(`${API_URL}/onboarding/create-organization-settings`, input, {
				headers: { Authorization: sessionContext?.sessionId ?? '' },
			});
			return data;
		},
	});
};
